import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getPackWidgets, updatePack, resetPackWidgets } from '../actions';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import Snackbar from 'material-ui/Snackbar';
import { black, lightGreenA700, yellowA400 } from 'material-ui/styles/colors';

const ControlWrapper = styled.div`
    text-align: center;
    margin: 20px;

    > * {
        margin: 0 10px;
    }
`;

const SnackbarContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        margin-left: 10px;
        font-size: 1.2em;
        color: black;
    }
`;

const ErrorText = styled.h3`
    margin-bottom: 20px;
    color: red;
`;

const snackbarSavingStyle = {
    backgroundColor: lightGreenA700
};

const snackbarSaveStyle = {
    backgroundColor: yellowA400
};

function SnackbarContent({ text, isLoader }) {
    return (
        <SnackbarContentWrapper>
            {isLoader && <CircularProgress size={30} thickness={3} color={black} />}
            <span>{text}</span>
        </SnackbarContentWrapper>
    );
}

SnackbarContent.propTypes = {
    text: PropTypes.string.isRequired,
    isLoader: PropTypes.bool
};

class ButtonControlWrapper extends Component {
    state = {
        saving: false,
        saveSuccessful: false,
        error: false
    };

    handleClose = () => {
        this.setState(() => ({ saving: false, saveSuccessful: false }));
    };

    handleSave = () => {
        const { packId, packWidgets, updatePack } = this.props;

        this.setState({ saving: true, saveSuccessful: false });

        Promise.resolve(updatePack(packId, packWidgets)).then(res => {
            if (res.status === 200) {
                this.setState({ saving: false, saveSuccessful: true });
            } else {
                this.setState({ saving: false, error: true });
            }

            return res;
        });
    };

    handleReset = () => {
        const { packId, packWidgetsDefault, getPackWidgets, resetPackWidgets, isEditPackWidgets = true } = this.props;

        if (isEditPackWidgets) {
            getPackWidgets(packId, packWidgetsDefault);
            resetPackWidgets();
        }
    };

    render() {
        const { saving, saveSuccessful, error } = this.state;

        return (
            <ControlWrapper>
                {error && <ErrorText>An error occurred while saving, refresh the page, or try again later!</ErrorText>}
                <RaisedButton secondary disabled={error || saving} label="Save" onTouchTap={this.handleSave} />
                <RaisedButton disabled={error || saving} label="Reset to previous" onTouchTap={this.handleReset} />
                <Snackbar
                    open={!saveSuccessful && saving}
                    message={<SnackbarContent text="Saving pack..." isLoader />}
                    onRequestClose={this.handleClose}
                    bodyStyle={snackbarSavingStyle}
                />
                <Snackbar
                    open={saveSuccessful}
                    message={<SnackbarContent text="Save" />}
                    autoHideDuration={3000}
                    onRequestClose={this.handleClose}
                    bodyStyle={snackbarSaveStyle}
                />
            </ControlWrapper>
        );
    }
}

ButtonControlWrapper.propTypes = {
    // From connect
    packId: PropTypes.string.isRequired,
    packWidgets: PropTypes.array.isRequired,
    packWidgetsDefault: PropTypes.array.isRequired,
    isEditPackWidgets: PropTypes.bool,
    updatePack: PropTypes.func.isRequired,
    getPackWidgets: PropTypes.func.isRequired,
    resetPackWidgets: PropTypes.func.isRequired
};

export default connect(
    ({ packs, requery = { entities: { packs: {} } } }) => {
        const pack = Object.values(requery.entities.packs).find(pack => pack._id === packs.editPackId);

        return {
            packId: packs.editPackId || '',
            packWidgets: packs.editPackWidgets || [],
            packWidgetsDefault: pack ? pack.widgets : [],
            isEditPackWidgets: packs.isEditPackWidgets
        };
    },
    { updatePack, getPackWidgets, resetPackWidgets }
)(ButtonControlWrapper);



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/ButtonControlWrapper.js
 **/